import { action, computed, observable, runInAction } from "mobx";
import { ApiResult, FieldType, ViewModelBase } from "@shoothill/core";
import React, { useState, useContext } from "react";
import { RegistrationTypeEnum } from "Globals/Models/RegistrationTypeEnum";
import { AppUrls } from "AppUrls";
import { StoresInstance } from "Globals/Stores";

// Model
import { NewApplicantRequestModel } from "Globals/Models/Domain/Admin/NewApplicantRequestModel";
import { NewApplicantRequestDTO } from "Globals/Models/DTO/NewApplicantRequestDTO";
const domainStores = StoresInstance.Domain;

export default class NewApplicantRequestViewModel extends ViewModelBase<NewApplicantRequestModel> {
    @observable public sendEmail: boolean = false;
    @observable public sendSMS: boolean = false;
    @observable public errorMessage: string = "";
    constructor() {
        super(new NewApplicantRequestModel());
    }

    public createNewApplicant = async (): Promise<boolean> => {
        this.setIsLoading(true);
        try {
            let isMyModelValid: boolean = await this.isModelValid();
            if (isMyModelValid) {
                let upsert: NewApplicantRequestDTO = this.model.toDto();
                const apiResult = await this.Post<NewApplicantRequestDTO>(AppUrls.Server.Admin.NewApplicantRequest, upsert);
                if (apiResult.wasSuccessful) {
                    this.model.fromDto(apiResult.payload);
                    domainStores.OpenSnackBar("New applicant created", "success");
                    console.info("NewApplicantRequest:Successful");
                    return true;
                } else {
                    console.error("NewApplicantRequest:Error", apiResult.errors);
                    apiResult.errors.forEach((error) => {
                        domainStores.OpenSnackBar(`Error: ${error.message}`, "error");
                    });
                    runInAction(() => {
                        this.errorMessage = apiResult.errors[0].message;
                    });
                    return false;
                }
            }
        } catch (exception) {
            console.log("Error:", exception);
        } finally {
            this.setIsLoading(false);
        }
        return false;
    };

    @action
    public handleCheckboxChange = (type: RegistrationTypeEnum, val: boolean): void => {
        let regType = RegistrationTypeEnum.DontSend;

        if (type == RegistrationTypeEnum.Email) {
            this.sendEmail = val;
        }
        if (type == RegistrationTypeEnum.SMS) {
            this.sendSMS = val;
        }
        if (this.sendEmail == true && this.sendSMS == true) {
            regType = RegistrationTypeEnum.Both;
        } else if (this.sendEmail == true) {
            regType = RegistrationTypeEnum.Email;
        } else if (this.sendSMS == true) {
            regType = RegistrationTypeEnum.SMS;
        }

        this.setValue("registrationType", regType);
    };

    public async isFieldValid(fieldName: keyof FieldType<NewApplicantRequestModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;
}
